import { render, staticRenderFns } from "./WeeklyForm.vue?vue&type=template&id=30287210&"
import script from "./WeeklyForm.vue?vue&type=script&lang=js&"
export * from "./WeeklyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports